import React from 'react';

import { styTooltipMarker } from './style';

const Marker = props => <div className={styTooltipMarker(props)} />;

export default Marker;
